@if (question) {
  <div class="main-wrapper">
    <!-- Main title -->
    <ion-text color="tertiary">
      <h3 class="title">{{ question.question }}</h3>
    </ion-text>
    <!-- end: main title -->
    <!-- Dichotomous question -->
    @if (question.type === 'dichotomous') {
      <div class="circles-wrapper">
        <div (click)="onRadioClick('true')" class="circle-wrapper left-circle">
          <div class="circle">
            @if (question.answer === 'true') {
              <div class="inner-circle"></div>
            }
          </div>
          <div class="circle-label">
            <ion-text color="tertiary">
              @switch (checklistType) {
                @case (checklistTypes.yesNo) {
                  {{ 'checklistModal.yes' | translate }}
                }
                @case (checklistTypes.goodBad) {
                  {{ 'checklistModal.good' | translate }}
                }
              }
            </ion-text>
          </div>
        </div>
        <div class="circle-wrapper right-circle">
          <div (click)="onRadioClick('false')" class="circle">
            @if (question.answer === 'false') {
              <div class="inner-circle"></div>
            }
          </div>
          <div class="circle-label">
            <ion-text color="tertiary">
              @switch (checklistType) {
                @case (checklistTypes.yesNo) {
                  {{ 'checklistModal.no' | translate }}
                }
                @case (checklistTypes.goodBad) {
                  {{ 'checklistModal.bad' | translate }}
                }
              }
            </ion-text>
          </div>
        </div>
        <div class="circle-wrapper center-circle">
          <div (click)="onRadioClick(undefined)" class="circle">
            @if (question.answer === 'undefined') {
              <div class="inner-circle"></div>
            }
          </div>
          <div class="circle-label">
            <ion-text color="tertiary">
              {{ 'checklistModal.noAnswer' | translate }}
            </ion-text>
          </div>
        </div>
      </div>
    }
    <!-- end: Dichotomous question -->
    <!-- Note and open -->
    @if (question.type === 'note') {
      <div class="text-area">
        <ion-textarea
          inputmode="text"
          maxlength="{{ maxTextAreaLength }}"
          color="tertiary"
          [value]="question.answer"
          [rows]="15"
          debounce="500"
          (ionChange)="onTextAreaChange($event.target['value'])"
        ></ion-textarea>
      </div>
    }
    <!-- end: Note and open -->
    <!-- Signature -->
    @if (question.type === 'signature') {
      <div class="ion-text-left">
        <app-signature #signature (signatureChanged)="onSignatureChange(signature)"></app-signature>
      </div>
    }
    <!-- end: Signature -->
  </div>
}
